import { useReducer } from "react";
import useToggle from "../../../hook/useToggle";
import { Action } from "../../../types/reducer-action";
import AccordionContainer from "../../common/accordion-container";
import { DataEntryEvent } from "../../common/data-entry-reducer";
import { AddIcon } from "../../common/icons";
import AddressDetailsPane from "./address-details-pane";
import { AddressContext, AddressDispatchContext, AddressState, addressReducer, useAddressDispatch } from "./address-manager-context";
import AddressSearchForm from "./address-search-form";
import AddressSearchResultsTable from "./address-search-results-table";
import BusinessEntityPane from "./business-entity/business-entity-pane";
import NewAddressModal from "./new-address-modal";
import Button from "../../common/button";

export function AddressManager() {
  const [state, dispatch] = useReducer(addressReducer, {} as AddressState);

  return (
    <AddressContext.Provider value={state}>
      <AddressDispatchContext.Provider value={dispatch}>
        <AddressActionPane />

        <AddressSearchPane />

        <AddressDetailsPane />

        <BusinessEntityPane />
      </AddressDispatchContext.Provider>
    </AddressContext.Provider>
  );
}

function AddressActionPane() {
  const dispatch = useAddressDispatch();

  const { isOpen: isCreationModalOpen, toggle: toggleCreationModal } = useToggle();

  const handleNew = () => {
    dispatch(new Action(DataEntryEvent.NewForm));
    toggleCreationModal();
  };


  return (
    <div>
      <Button type="button" color="primary" className="action-link"
        onClick={handleNew} >
        <AddIcon /> Create New Address
      </Button>

      <NewAddressModal isOpen={isCreationModalOpen} toggle={toggleCreationModal} />
    </div>
  );
}

function AddressSearchPane() {
  return (
    <AccordionContainer title="Search Addresses">
      <AddressSearchForm />

      <AddressSearchResultsTable pageSize={10} />
    </AccordionContainer>
  );
}
